import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@Components/TextField';
import { ReactHookFormError } from '@Typings/global.types';

import TextFieldWrapperProps from './TextFieldWrapper.types';

const TextFieldWrapper: FunctionComponent<TextFieldWrapperProps> = (
  props: TextFieldWrapperProps
): JSX.Element => {
  const { label, placeholder, name, onChange, initialValue, ...resProps } =
    props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={initialValue}
      render={({ field: { ref, ...resField } }) => (
        <TextField
          {...resProps}
          {...resField}
          onChange={(
            e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
          ) => {
            if (onChange) {
              onChange(e);
            }
            resField.onChange(e);
          }}
          label={label}
          variant="outlined"
          placeholder={placeholder}
          error={!!errors[name]}
          helperText={(errors[name] as ReactHookFormError)?.message}
        />
      )}
    />
  );
};

TextFieldWrapper.defaultProps = {
  initialValue: '',
};

export default TextFieldWrapper;
